import { keysToSnakeCaseDeep } from '@agro1desenvolvimento/utils-js';
import Yup from './yup';

export class SchemaParseError extends Error {
  readonly errors: string[];

  constructor(errors: string[], options?: { cause?: unknown }) {
    super(errors[0] ?? 'Dados fora do contrato esperado.', options);
    this.name = 'SchemaParseError';
    this.errors = errors;
  }
}

export const orDash = (value: unknown): string => {
  if (value === null || value === undefined || value === '') return '-';

  return String(value);
};

const validate = <TSchema extends Yup.Schema>(
  schema: TSchema,
  value: unknown,
): Yup.InferType<TSchema> => {
  try {
    return schema.validateSync(value, {
      abortEarly: false,
      stripUnknown: true,
    }) as Yup.InferType<TSchema>;
  } catch (error) {
    if (Yup.ValidationError.isError(error)) {
      throw new SchemaParseError(error.errors, { cause: error });
    }

    throw error;
  }
};

export const parseResponse = <TSchema extends Yup.Schema>(
  schema: TSchema,
  data: unknown,
): Yup.InferType<TSchema> => validate(schema, data);

export const parseRequest = <TSchema extends Yup.Schema>(
  schema: TSchema,
  values: unknown,
): Yup.InferType<TSchema> => validate(schema, values);

export const toSnakePayload = <T extends Record<string, unknown>>(values: T) =>
  keysToSnakeCaseDeep(values);
